module.exports = __webpack_public_path__ + "assets/images/8c4aa79f8b7bcb8e863d632a7934de4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/top-doc-2021.png
// module id = 411
// module chunks = 0